"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (state) => {
    var _a, _b, _c, _d, _e, _f, _g;
    return (_g = (_f = (_e = (_d = (_c = (_b = (_a = state.plugins) === null || _a === void 0 ? void 0 : _a.get('SOLUTION_EXPLORER')) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.explorer) === null || _d === void 0 ? void 0 : _d.items) === null || _e === void 0 ? void 0 : _e.get(0)) === null || _f === void 0 ? void 0 : _f.dataRef) === null || _g === void 0 ? void 0 : _g.secretKey;
};
//# sourceMappingURL=getCurrentProjectSecretKey.js.map